import { render, staticRenderFns } from "./Social.vue?vue&type=template&id=8de86e12&scoped=true"
import script from "./Social.vue?vue&type=script&lang=js"
export * from "./Social.vue?vue&type=script&lang=js"
import style0 from "./Social.vue?vue&type=style&index=0&id=8de86e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de86e12",
  null
  
)

export default component.exports